import { Component, OnInit } from '@angular/core';
import { FieldConfig } from 'src/app/modules/_models/field.interface';
import { FidelidadeService } from 'src/app/modules/_services/fidelidade.service';
import { exibirToast } from 'src/app/modules/_functions/alerts';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthService } from 'src/app/modules/_services/auth.service';

@Component({
  selector: 'app-desafios-carousel',
  templateUrl: './desafios-carousel.component.html',
  styleUrls: ['./desafios-carousel.component.scss'],
})
export class DesafiosCarouselComponent implements OnInit {
  field: FieldConfig;

  exibirDesafioCompleto: boolean = false;
  exibirDesafioIncompleto: boolean = false;

  regDesafios: FieldConfig[] = [];
  regConfigSemDesafios: FieldConfig[] = [];
  carregandoDesafios: boolean = false;

  constructor(
    private fidelidade: FidelidadeService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.exibirDesafioCompleto = this.field.desafio.exibirDesafioCompleto;
    this.exibirDesafioIncompleto = this.field.desafio.exibirDesafioIncompleto;

    this.registrarElementosDaPagina();
    this.obterDesafios();
  }

  registrarElementosDaPagina() {
    this.regConfigSemDesafios = [];
    this.regDesafios = [];

    let semDesafioLabel = '';
    if (this.exibirDesafioCompleto && this.exibirDesafioIncompleto) {
      semDesafioLabel = 'Em breve teremos desafios para você';
    } else if (this.exibirDesafioCompleto && !this.exibirDesafioIncompleto) {
      semDesafioLabel = 'Nenhum desafio foi completado';
    } else {
      semDesafioLabel = 'Em breve teremos desafios para você';
    }

    this.regConfigSemDesafios = [
      {
        type: 'noData',
        label: semDesafioLabel,
      },
    ];
  }

  obterDesafios() {
    this.carregandoDesafios = true;
    var membro = this.authService.LocalStorage.obterMembro();
    this.fidelidade.obterDesafios(membro.cpf).subscribe(
      (res) => this.processarSucessoObterDesafios(res),
      (err) => this.processarFalhaObterDesafios(err)
    );
  }

  processarSucessoObterDesafios(res: any) {
    res.forEach((desafio) => {
      const porcentagem = desafio.desafiosMembros[0]?.porcentagemFeita;
      const desafioCompleto = porcentagem === 100;

      if (!this.exibirDesafioCompleto && desafioCompleto) return;
      if (!this.exibirDesafioIncompleto && !desafioCompleto) return;

      this.regDesafios.push({
        type: 'circleProgress',
        class: 'carousel-cell',
        circleProgress: {
          color: desafio.cor,
          value: porcentagem,
          maxValue: 100,
          porcent: porcentagem,
          radius: 40,
          backgroundColor: '#E8DFCA',
          onClick: () => {
            this.router.navigate([`/missoes/${desafio.id}`]);
          },
        },
        desafio: {
          src: this.sanitizer.bypassSecurityTrustResourceUrl(
            'data:image/jpeg;base64,' + desafio.imagemLogoBase64
          ),
          resgatado: desafioCompleto,
          exibirSaibaMais: true,
        },
        styleDivPrincipal(): object {
          return {
            width: '102px',
          };
        },
      });
    });

    this.carregandoDesafios = false;
  }

  processarFalhaObterDesafios(err: any) {
    this.carregandoDesafios = false;
    console.error('Ocorreu um erro ao obter os desafios', err);
  }
}
